import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import './FooterCart.css';
import { useCart } from '../../contexts/CartContext';

const FooterCart = () => {
  const navigate = useNavigate();
  const { cartItemCount, cartItemTotal } = useCart(); // cartTotal: precisa estar disponível no seu contexto

  if (cartItemCount === 0) return null;

  return (
    <div
      onClick={() => navigate('/cart')}
      className="footerCartContainer"
    >
      <button id="btnVerCarrinho" className="footerCartButton">
        <div className="footerCartContent">
          <div className="footerCartLeft">
            <FaShoppingCart className="footerCartIcon animated-cart" />
            <span style={{ marginLeft: 4 }}>({cartItemCount})</span>
          </div>
          <div className="footerCartCenter">Ver carrinho</div>
          <div className="footerCartRight">R$ {cartItemTotal?.toFixed(2)}</div>
        </div>
      </button>
    </div>
  );
};

export default FooterCart;
